import {
  Box,
  Center,
  Flex,
  Icon,
  IconButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Skeleton,
  Spacer,
  Text,
} from '@chakra-ui/react'
import { SafeArea } from 'capacitor-plugin-safe-area'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { getSuggestedEvents } from '../../api/user/notifications/Notifications'
import { getSkillLevelDisplay } from '../../functions/Capitalize'
import { getEventLabel } from '../../types/EventTypes'
import EventJoinedCard from '../cards/EventJoinedCard'
import { ArrowLeft, EventsRacket } from '../icons/icons'

// const SKILL_LEVELS: any = ['Beginner', 'Intermediate', 'Intermediate High', 'Advanced', 'Advanced 4.5+', 'Mixed-Level']

const NotificationSwitchEventModal = ({
  isTablet,
  isMobile,
  isOpen,
  onClose,
  onSwitch,
  eventId,
  isLoading,
}: {
  isTablet: boolean
  isMobile: boolean
  isOpen: boolean
  onClose: () => void
  onSwitch: (id: string) => void
  eventId: string
  isLoading: boolean
}) => {
  const suggestedEvents = useQuery(['suggestedEvents'], () => getSuggestedEvents({ id: eventId }), {
    enabled: isOpen,
    refetchOnWindowFocus: false,
  })

  const [switched, setSwitched] = useState(-1)

  const [statusBarHeight, setStatusBarHeight] = useState<number>(0)
  useEffect(() => {
    SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
      setStatusBarHeight(statusBarHeight)
    })
  }, [])

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={isMobile ? 'full' : '6xl'} scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent p="0">
        {isMobile ? <></> : <ModalCloseButton zIndex={1} />}
        <ModalBody p={isMobile ? '0px 20px 20px 20px' : '30px'} overflowY="auto" mt="0">
          {isMobile ? (
            <Box w="100%" p="20px 0" position="sticky" top="0" bg="white" zIndex={1}>
              <Spacer h={statusBarHeight + 'px'} />
              <IconButton
                minW="32px"
                h="32px"
                variant="light"
                aria-label="back"
                onClick={onClose}
                icon={
                  <Icon width="20px" height="19px" viewBox="0 0 23 20">
                    <ArrowLeft color="#171C22" />
                  </Icon>
                }
              />
            </Box>
          ) : (
            <></>
          )}
          <Flex justifyContent="space-between" alignItems="center" m="30px 0">
            <Text variant="title" fontSize={isMobile ? '17px' : undefined}>
              Suggested Events
            </Text>
          </Flex>

          <Box maxH="calc(100vh - 300px)" overflowY="auto">
            <Flex gap="20px" flexWrap="wrap">
              {!suggestedEvents.isFetching && suggestedEvents.data?.suggestions.length === 0 && (
                <Center w="100%" flexDir="column" gap="20px" mt="40px">
                  <Icon w={isMobile ? 202 : 323} h={isMobile ? 154 : 246} viewBox="0 0 323 246">
                    <EventsRacket />
                  </Icon>
                  <Text color="#171C22" fontWeight="400" fontSize="md">
                    There are no suggested events
                  </Text>
                  {/* <Button
                    variant="heavy"
                    onClick={() => {
                      setIsHost(false)
                      navigate('/user/play')
                    }}
                  >
                    Find events
                  </Button> */}
                </Center>
              )}
              {suggestedEvents.isFetching
                ? [1, 1, 1, 1].map((_, idx) => (
                    <Skeleton
                      key={idx}
                      w={isTablet || isMobile ? '100%' : 'calc(50% - 10px)'}
                      h="305px"
                      borderRadius="10px"
                    />
                  ))
                : suggestedEvents?.data?.suggestions.map((event: any, index: number) => {
                    return (
                      <Box key={index} w={isTablet || isMobile ? '100%' : 'calc(50% - 10px)'}>
                        <EventJoinedCard
                          onExtraOptionsOpen={() => {}}
                          width="100%"
                          onCancel={() => {}}
                          onSwitchTime={() => {}}
                          onSwitchSelect={() => {
                            onSwitch(event.id)
                            setSwitched(index)
                          }}
                          isTablet={isTablet}
                          host={{
                            id: event.host?.id,
                            name: event.host?.display_name,
                            avatar: event.host?.profile_image,
                          }}
                          coach={event.coaches.map((coach: any) => {
                            return {
                              id: coach.id,
                              name: coach.display_name,
                              avatar: coach.profile_image,
                            }
                          })}
                          players={event.participants.map((participant: any) => {
                            return {
                              id: participant.id,
                              name: participant.display_name,
                              avatar: participant.profile_image,
                              follows: participant.follows,
                              is_child: participant.is_child,
                            }
                          })}
                          title={event.title}
                          time={new Date(event.start_time)}
                          type={getEventLabel(event.type)}
                          court={event.court}
                          level={getSkillLevelDisplay(event.skill_level)}
                          location={event.venue.address}
                          address={event.venue.address}
                          duration={event.duration}
                          isLoading={isLoading && switched === index}
                          isCancelled={event.status.status === 'cancelled'}
                          thumbnail={event.venue.images.length > 0 ? event.venue.images[0] : ''}
                          isSwitchable={true}
                        />
                      </Box>
                    )
                  })}
            </Flex>
          </Box>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default NotificationSwitchEventModal
